import { IndividualResult } from '@athleticnet/athletic-live-api-models/lib/models/shared/individual-result.interface';

export class AthleteModalDataModel {
  athleteId: number;
  result?: IndividualResult;
  openOnPageLoad: boolean = false;
  currentAttemptId?: number;
  currentJumpId?: number;
  constructor(athleteId: number, result?: IndividualResult, currentAttemptId?: number, currentJumpId?: number) {
    this.athleteId = athleteId;
    this.result = result;
    this.currentAttemptId = currentAttemptId;
    this.currentJumpId = currentJumpId;
  }
}
